
export const CHANGE_SCULPT_TOOL_WIZARD_DIMENSION = 'CHANGE_SCULPT_TOOL_WIZARD_DIMENSION';

export interface ISculptToolWizardState {
  visible: boolean
  height: number
  width: number
  x: number
  y: number
}

export interface ChangeSculptToolWizardDimensionAction {
  type: typeof CHANGE_SCULPT_TOOL_WIZARD_DIMENSION
  payload: {
    height?: number
    width?: number
    x?: number
    y?: number
  }
}

